/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { FilterItem } from '../../components/filter/filterItem';
import FilterMobileMenu, { FilterType } from '../../components/filter/filterMobileMenu';
import { ISelectableItem, SelectableItemConverter } from '../../components/selectableItem/selectableItemConverters';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';
import { ResourceProvider } from '../../resourceProvider';
import { ApplicationState } from '../../store';
import { showCountriesPage } from '../../store/countriesPage/actions';
import { resetAll } from '../../store/filterPage/actions';
import { showWizardPage } from '../../store/wizardPage/actions';
import { TrackingProvider } from '../../tracking/trackingProvider';
import { getDefaultCountry } from '../../utils/api';

interface IPropsFromState {
    readonly selectedCountry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly enteredVin: string,
    readonly selectedVehicleMarketEntry: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.CodeListItemModel,
    readonly selectedModel: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel,
    readonly selectedInfotaiment: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel,
    readonly selectedProductionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel,
    readonly importerSettings: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.ImporterSettingsModel,
    readonly culture: string,
    readonly importerBid: string,
    readonly countries: ISelectableItem[],
    readonly importerCountryCode: string,
    readonly trackingProvider: TrackingProvider
}

interface IPropsFromDispatch {
    readonly showCountriesPage: typeof showCountriesPage,
    readonly showWizardPage: typeof showWizardPage,
    readonly resetAll: typeof resetAll
}

type IFilterProps = IPropsFromState & IPropsFromDispatch

class FilterPage extends React.Component<IFilterProps, {}>
{
    constructor(props: IFilterProps) {
        super(props);
        this.onClickShowCountriesPage = this.onClickShowCountriesPage.bind(this);
        this.onClickShowWizardPage = this.onClickShowWizardPage.bind(this);
        this.activateWizardPage = this.activateWizardPage.bind(this);
        this.onClickReset = this.onClickReset.bind(this);
    }

    public componentDidMount() {
        this.filterResetPosition();
        window.onresize = () => {
            this.filterResetPosition();
        }


    }

    public componentDidUpdate(prevProps: IFilterProps) {
        if (this.props.importerCountryCode && this.props.countries && this.props.countries.length > 0 &&
            (this.props.importerCountryCode !== prevProps.importerCountryCode
                || this.props.countries.length !== prevProps.countries.length)) {

            const defaultCountry = getDefaultCountry(this.props.countries, this.props.importerCountryCode);
            if (!defaultCountry) {
                this.props.trackingProvider.trackPageView(this.props.importerBid, this.props.culture, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
            }
        }
    }

    private filterResetPosition() {
        let filterReset = document.getElementById("filter-reset");
        if (filterReset) {
            var height = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;
            if (height > 1080) {
                height = 1080;
            }
            filterReset.style.top = (height - 60) + 'px';
        }
    }

    public render() {
        let showOtherFilterOptions: boolean = (this.props.enteredVin || this.props.selectedModel || this.props.selectedProductionInterval || this.props.selectedInfotaiment) ? true : false;
        let type: FilterType = this.props.enteredVin ? FilterType.Full : this.props.selectedModel ? (this.props.selectedProductionInterval && this.props.selectedInfotaiment ? FilterType.Full : FilterType.Partial) : FilterType.NoCar;
        let isEnteredVin: boolean = this.props.enteredVin != null ? true : false;

        return (
            <div id="filter-container" className="filter-container">
                <div className="filter-desktop">
                    {this.renderSvgImageDesktop()}
                    <div className="filter-desktop-content">
                        <div className="filter-wrapper-first-part">
                            <FilterItem resourceTitle='Filter.Country.Label' value={this.props.selectedCountry ? this.props.selectedCountry.Value : 'Filter.Item.Unselected'}
                                isSelected={this.props.selectedCountry ? true : false} activateWizardTab={null} onclickFunction={this.onClickShowCountriesPage} />

                        </div>
                        <div className="filter-wrapper-second-part">
                            {isEnteredVin && showOtherFilterOptions ?
                                <FilterItem resourceTitle='Filter.Vin.Label' value={this.props.enteredVin ? this.props.enteredVin : 'Filter.Item.Unselected'}
                                    isSelected={this.props.enteredVin ? true : false} activateWizardTab={TabType.Vin} onclickFunction={this.activateWizardPage} />
                                : null
                            }
                            {showOtherFilterOptions ?
                                <FilterItem resourceTitle='Filter.Model.Label' value={this.props.selectedModel ? this.props.selectedModel.Title : 'Filter.Item.Unselected'}
                                    isSelected={this.props.selectedModel ? true : false} activateWizardTab={TabType.Model} onclickFunction={!isEnteredVin ? this.activateWizardPage : null} />
                                : null
                            }
                            {showOtherFilterOptions ?
                                <FilterItem resourceTitle='Filter.Intofaiment.Label' value={this.props.selectedInfotaiment ? this.props.selectedInfotaiment.Title : 'Filter.Item.Unselected'}
                                    isSelected={this.props.selectedInfotaiment ? true : false} activateWizardTab={TabType.Infotainment} onclickFunction={!isEnteredVin ? this.activateWizardPage : null} />
                                : null
                            }
                            {showOtherFilterOptions ?
                                <FilterItem resourceTitle='Filter.ProductionPeriod.Label' value={this.getProductionIntervalValue(this.props.selectedProductionInterval)}
                                    isSelected={this.props.selectedProductionInterval ? true : false} activateWizardTab={TabType.ProductionPeriod} onclickFunction={!isEnteredVin ? this.activateWizardPage : null} />
                                : null
                            }
                            {!showOtherFilterOptions ?
                                <div className="filter-action">
                                    <p className="filter-label">{ResourceProvider.getText('Filter.Action.Label')}</p>
                                    {this.props.selectedCountry ?
                                        <button className="btn btn-sa-primary btn-availability-primary filter-button button-border-radius" onClick={this.onClickShowWizardPage}>
                                            {ResourceProvider.getText('Filter.Action.Button')}
                                        </button>
                                        :
                                        <button disabled className="btn btn-sa-primary btn-availability-primary filter-button button-border-radius">
                                            {ResourceProvider.getText('Filter.Action.Button')}
                                        </button>
                                    }
                                </div> : null
                            }
                        </div>
                    </div>
                    <div id="filter-reset" className="filter-reset" onClick={this.onClickReset}>
                        <div className="filter-reset-button">{ResourceProvider.getText('Filter.Action.Reset')}</div>
                        <div className="filter-reset-image"></div>
                    </div>
                </div>
                <div id="filter-mobile" className="filter-mobile">
                    <FilterMobileMenu selectedCountryValue={this.props.selectedCountry ? this.props.selectedCountry.Value : 'Filter.Item.Unselected'}
                        filterType={type} isCountrySelected={this.props.selectedCountry ? true : false} onShowCountriesPage={this.onClickShowCountriesPage} onShowWizardPage={this.onClickShowWizardPage} />
                </div>
            </div>
        );
    }

    private renderSvgImageDesktop(): JSX.Element {
        return (
            <div className="filter-desktop-background">
                <div className="filter-desktop-background-first" />
            </div>
        );
    }

    private getProductionIntervalValue(productionInterval: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel): string {
        if (productionInterval) {
            let result = '';
            if (productionInterval.From) {
                result = ResourceProvider.getText('Filter.ProductionInterval.PrefixFrom') + " " + productionInterval.From.Title;
            }
            if (productionInterval.To) {
                result += " " + ResourceProvider.getText('Filter.ProductionInterval.PrefixTo') + " " + productionInterval.To.Title;
            }
            return result;
        }
        return 'Filter.Item.Unselected';
    }

    private onClickShowCountriesPage(): void {
        this.props.trackingProvider.trackButtonClick('Select country', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        this.props.showCountriesPage();
    }

    private activateWizardPage(activeWizardTab: TabType): void {
        if (activeWizardTab == TabType.Model) {
            this.props.trackingProvider.trackButtonClick('Select vehicle model', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        } else if (activeWizardTab == TabType.Infotainment) {
            this.props.trackingProvider.trackButtonClick('Select vehicle infotainment', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        } else if (activeWizardTab == TabType.ProductionPeriod) {
            this.props.trackingProvider.trackButtonClick('Select vehicle production period', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        } else if (activeWizardTab == TabType.Vin) {
            this.props.trackingProvider.trackButtonClick('Enter VIN code', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        }

        this.activateWizardPageCore(activeWizardTab);
    }

    private activateWizardPageCore(activeWizardTab: TabType): void {
        this.props.showWizardPage(activeWizardTab, false, (this.props.importerSettings && this.props.importerSettings.VinCheck) ? true : false);
    }

    private onClickShowWizardPage(): void {
        this.props.trackingProvider.trackButtonClick('Select vehicle', null, this.props.selectedCountry?.OriginValue, this.props.selectedInfotaiment?.Title, this.props.selectedModel?.Code, this.props.selectedProductionInterval?.From?.ProductionDate);
        //user clicked on SelectCar button
        if (this.props.importerSettings && this.props.importerSettings.VinCheck) {
            this.activateWizardPageCore(TabType.Vin);
        }
        else {
            this.activateWizardPageCore(TabType.Model);
        }
    }

    private onClickReset(e: any): void {
        e.preventDefault();
        this.props.resetAll();
        this.props.trackingProvider.trackButtonClick('Reset filter');
        this.props.trackingProvider.trackPageView(this.props.importerBid, this.props.culture);
    }
}

const mapStateToProps = ({ filter, common }: ApplicationState) => ({
    selectedCountry: filter.selectedCountry,
    enteredVin: filter.enteredVin,
    selectedVehicleMarketEntry: filter.selectedVehicleMarketEntry,
    selectedModel: filter.selectedModel,
    selectedInfotaiment: filter.selectedInfotaiment,
    selectedProductionInterval: filter.selectedProductionInterval,
    importerSettings: common.importerSettings,
    culture: filter.dataFilter.Culture,
    importerBid: filter.dataFilter.ImporterBid,
    countries: SelectableItemConverter.convertCountries(common.countries),
    importerCountryCode: common.importerSettings ? common.importerSettings.CountryCode : null,
    trackingProvider: common.trackingProvider
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
    showCountriesPage: () => dispatch(showCountriesPage()),
    showWizardPage: (wizardTab: TabType, activateFilterOnClose: boolean, vinCheck: boolean) => dispatch(showWizardPage(wizardTab, activateFilterOnClose, vinCheck)),
    resetAll: () => dispatch(resetAll())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FilterPage)